import { styled } from 'styled-components'

export const Table = styled.table`
  border-collapse: collapse;
  width: 100%;

  thead {
    height: 34px;
    padding: 8px;
    align-items: center;
    background: var(--surface-main, #f7f7f7);
  }
  tbody {
    tr {
      vertical-align: middle;
    }
  }
`

export const NumberTd = styled.td`
  width: 50px;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.28px;
  color: var(--text-disabled, #bfbfbf);
  text-align: center;
  vertical-align: middle;
`

export const FIleOrIndex = styled.td`
  vertical-align: middle;
  text-align: center;

  color: var(--text-disabled, #bfbfbf);
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.28px;
  float: left;
  margin-top: 10px;
`

export const Text = styled.td<{ signal: string }>`
  display: flex;
  align-items: center;
  ${({ signal }) => signal === 'true' && 'align-items: flex-start'};
  ${({ signal }) => signal === 'false' && 'justify-content: space-between'};

  div {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  svg {
    margin-left: 20px;
  }
`

export const Author = styled.td`
  div {
    display: flex;
    align-items: center;
    p {
      margin-left: 10px;
    }
  }
`

export const Unit = styled.td``

export const IndicatorValues = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const SignalValues = styled.div<{
  bgcolor?: string
  iscircle?: string
  textColor?: string
  color: string
  borderColor?: string
}>`
  border-radius: ${({ iscircle }) => (iscircle === 'true' ? '50%' : '8px')};
  padding: 1px 7px;
  border: 2.5px solid ${({ color, borderColor }) => (color || borderColor ? borderColor || color : 'var(--red-30, #f29b95)')};
  background: ${({ bgcolor }) =>
    bgcolor ? bgcolor : 'var(--red-10, #fcecea);'};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 3;
  text-decoration: none!important;
  height: 30px;
  min-width: 30px;

  text-overflow: ellipsis;
  font-family: Quicksand;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px; /* 150% */
  letter-spacing: 0.12px;
  color: ${({ textColor, color }) => (textColor || color ? textColor || color : 'gray')};
`

export const SignalLine = styled.span<{ color: string; width?: string }>`
  border: 1px solid ${({ color }) => (color ? color : 'gray')};
  width: ${({ width }) => width && width};
  min-width: 20px;
  max-height: 100px;
  height: 1px;
  position: relative;
`

export const AboutSignals = styled.div<{ color: string }>`
  height: 30px;
  display: flex;
  align-items: center;
  border-left: 3px solid ${({ color }) => (color ? color : 'gray')};
  border-radius: 3px;
  p {
    margin-left: 5px;
  }
  svg {
    margin-left: 5px;
    path {
      fill: gray;
    }
  }
`

export const Signal = styled.td<{ count: number }>`
  /* width: ${({ count }) => count * 20 + 'px'};  */
`

export const INDText = styled.p`
  margin-right: 5px;

  color: var(--text-secondary, #808080);
  /* Text/M */
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.28px;
`
